import { paths } from 'common/consts/path.consts';
import { roomTypes } from 'common/consts/room-types.consts';

export const getLinkPathToCollections = (type: string) => {
  if (type === roomTypes.tile) {
    return paths.ggrTile;
  }

  return paths.ggrWallpaper;
}
